import WindPlot from "../wind";
import WeatherPlot from "../weather";
import PressurePlot from "../pressure";
import { getStationData } from "../util";
import Box from "@mui/material/Box";


export default function Murtensee ({ forecast }) {

  // Get forecast for this station
  let [vmax, speed, dir, t2m, precip, dursun, twater, qff] = getStationData(forecast, "MUR", "murten", "QFF_KLO_GVE");

  return (
    <div>
      <title>Murtensee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Murtensee</h2>
          <h3>Bise Noire</h3>
          <Box sx={{ overflow: "auto" }}>
            <WindPlot vmax={vmax} speed={speed} dir={dir} />
            <PressurePlot qff={qff} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
            <WeatherPlot t2m={t2m} precip={precip} sun={dursun} twater={twater} />
          </Box>
        </div>
      </div>
    </div>
  );
};
